import { decorate, observable, action} from 'mobx';
import axios from 'axios';

import { materialTypes } from '../SearchInput';

class Searcher {
    error = null;
    unsupportMsg = null;
    unsupportMsgList = null;
    results = null;
    numResults = 0;

    constructor(params){
        this.clear();
    }

    query(url) {
        this.state="ongoing"
        this.error = null;
        this.unsupportMsg = null;
        this.unsupportMsgList = null;
        return axios.get(url)
            .then(response => {
                this.processResponse(response);
                this.state="successful"
                
            }).catch(err => {
                console.log(err);
                this.fillError(err);        
            });
    }

    fillUnsupported(msg, l=null) {
        this.unsupportMsg = msg;
        this.unsupportMsgList = l;
        this.state = "unsupported";
    }    

    fillError(err) {
        this.error = err;
        this.state = "error";
    }

    clear() {
        this.state="uninitialized";
        this.targetWebsiteUrl = null;
    }

    search(value, store) {
        
        console.log("in search");
        if (store.searchInput.selectedTypes.length === materialTypes.length || 
            store.searchInput.selectedTypes.length === 0) {
            store.searchInput.selectedTypes = ["All types"];
        } else {
            var unsupported_types = store.searchInput.selectedTypes.filter(n => {
                return Object.keys(this.typeFilter2urlSection).indexOf(n) === -1;
            });
    
            if (unsupported_types.length > 0) {
                this.fillUnsupported("unsupported filter", unsupported_types);
                return;
            }
            console.log(store.searchInput.selectedTypes.length, this.multiTypeFilterSupported)
            if (store.searchInput.selectedTypes.length > 1 && !this.multiTypeFilterSupported) {
                this.fillUnsupported("Source does not support filter by more than one filter type");
                return;
            }
        } 
        if (store.searchInput.dates !== null && !this.dateFilterSupported) {
            this.fillUnsupported("Source does not support filter by dates");
        }
        this.searchInternal(value, store)
    }


}

decorate(Searcher, {
        search: action.bound,
        clear: action.bound,
        results: observable,
        numResults: observable,
        state: observable,
        error: observable
    }
)

export default Searcher;

